function checkInputsAndCheckbox() {
    var allInputsFilled = true;
    
    $('.single_custom-bust > input').each(function() {
        if ($(this).val() === '') {
            allInputsFilled = false;
            return false; 
        }
    });
    var checkboxChecked = $('#return_support_checkbox').prop('checked');
    if (allInputsFilled && checkboxChecked) {
        $('.product-form__buttons button').prop('disabled', false);
    } else {
        $('.product-form__buttons button').prop('disabled', true);
    }
}


$('.single_item').click(function() {
    var formIdValue = $('.single_custom-size').attr('form-id');
    var index = $(this).index() - 1;
    $('.row-scroll tbody>tr').removeClass('active');
    $('.row-scroll tbody>tr:eq(' + index + ')').addClass('active');
    var size = $(this).find('div').text();
    $('.data-size-value').empty().text(size);

  

    // 检查是否包含 .single_item-custom
    if ($(this).hasClass('single_item-custom')) {
        $('.row-scroll').hide();     
      $('.shopify-payment-button').hide(); 
        $('.single_custom-size').show();  
  $('.product-form__buttons button').prop('disabled', true);
         var formIdValue = $('.single_custom-size').attr('form-id'); 
        $('.single_custom-bust>input').each(function() {
            $(this).attr('form', formIdValue); 
        });
      checkInputsAndCheckbox();
    } else {
      $('.product-form__buttons button').prop('disabled', false);
        $('.row-scroll').show();   
       $('.shopify-payment-button').show(); 
        $('.single_custom-size').hide();  
        $('.single_custom-bust>input').each(function() {
            $(this).removeAttr('form'); 
        });
    }
});




// custom size
$('.single_custom-label').click(function() {
    var sibling = $(this).siblings('.single_custom-inch');
    sibling.toggle();
    $('.single_custom-inch').not(sibling).hide();
  
      var dataTxt = $(this).data('txt'); 
    $('.single_custom-content-yang p').each(function() {
        if ($(this).data('txt') === dataTxt) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
});


$('.single_custom-inch > li').click(function() {
    var value = $(this).text();
    $(this).closest('.single_custom-inch').hide();
    $(this).closest('.single_custom-inch').siblings('.single_custom-label').text(value);
    $(this).closest('.single_custom-inch').siblings('input').val(value);
  checkInputsAndCheckbox()
});

$('.single_custom-footer').click(function() {
    $(this).find('input[type="checkbox"]').click();
   checkInputsAndCheckbox()
});